import { render, staticRenderFns } from "./KpmgImpactDashboard.vue?vue&type=template&id=68bb3a45&"
import script from "./KpmgImpactDashboard.vue?vue&type=script&lang=js&"
export * from "./KpmgImpactDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports